var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathtub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5 13V18H17.5V13H2.5V18C2.5 19.5913 3.13214 21.1174 4.25736 22.2426C5.38258 23.3679 6.9087 24 8.5 24H24.5C26.0913 24 27.6174 23.3679 28.7426 22.2426C29.8679 21.1174 30.5 19.5913 30.5 18V13H25.5Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 24V27",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24V27",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12H17.5V18H25.5V12Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13H30.5V18C30.5 19.5913 29.8679 21.1174 28.7426 22.2426C27.6174 23.3679 26.0913 24 24.5 24H8.5C6.9087 24 5.38258 23.3679 4.25736 22.2426C3.13214 21.1174 2.5 19.5913 2.5 18V13H17.5",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13V6.50001C7.5 5.83697 7.76339 5.20108 8.23223 4.73224C8.70107 4.2634 9.33696 4.00001 10 4.00001C10.5822 3.99864 11.1475 4.19617 11.6021 4.55988C12.0567 4.9236 12.3735 5.43168 12.5 6.00001",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtub);
export default __webpack_public_path__ + "static/media/Bathtub.c5b6a8181817caca611ab881e106e385.svg";
export { ForwardRef as ReactComponent };